module.exports = __webpack_public_path__ + "static/night-sky-with-exit-wounds-2d3dda5d4f203419b31726fdf8da4156.jpg";